namespace TabAurous.Scheme {
    export namespace SchemeEnrollmentService {
        export const baseUrl = 'Scheme/SchemeEnrollment';

        export declare function Create(request: Serenity.SaveRequest<SchemeEnrollmentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SchemeEnrollmentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SchemeEnrollmentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SchemeEnrollmentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Scheme/SchemeEnrollment/Create",
            Update = "Scheme/SchemeEnrollment/Update",
            Delete = "Scheme/SchemeEnrollment/Delete",
            Retrieve = "Scheme/SchemeEnrollment/Retrieve",
            List = "Scheme/SchemeEnrollment/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SchemeEnrollmentService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
